import { GoogleGenAI } from "@google/genai";
import { AI_MODEL_NAME } from "../constants";
import { Idea, Topic } from "../types";

export const generateAIResponse = async (
  userMessage: string,
  contextData: { ideas: Idea[]; topics: Topic[] },
  modelName: string = AI_MODEL_NAME
): Promise<string> => {
  // Use process.env.API_KEY directly as per @google/genai guidelines
  const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
  
  // Construct context string
  const contextString = `
    CURRENT DATE: ${new Date().toLocaleDateString()}
    
    TOPICS:
    ${contextData.topics.map(t => `- ${t.name} (ID: ${t.id})`).join('\n')}

    EXISTING CONTENT IDEAS:
    ${contextData.ideas.map(i => 
      `- [${i.isDone ? 'COMPLETED' : 'PENDING'}] ${i.title} (${i.priority} Priority, Topic: ${contextData.topics.find(t => t.id === i.topicId)?.name || 'Unknown'})
       Description: ${i.description}`
    ).join('\n')}
  `;

  const systemInstruction = `You are an expert Content Strategist Assistant. 
  Your goal is to help the user develop new content ideas, refine existing ones, and analyze their content strategy.
  
  You have access to the user's current database of ideas and topics.
  
  Formatting Rules:
  - Use **Bold** for emphasis.
  - Use tables for comparing ideas or data.
  - Use bullet points for lists.
  - Do NOT use plain markdown blocks for code unless it is actual code.
  - Be concise, actionable, and creative.
  `;

  try {
    const response = await ai.models.generateContent({
      model: modelName,
      contents: `Context:\n${contextString}\n\nUser Query: ${userMessage}`,
      config: {
        systemInstruction: systemInstruction,
      }
    });

    // Directly access text property
    return response.text || "I couldn't generate a response.";
  } catch (error) {
    console.error("Gemini API Error:", error);
    return "Sorry, I encountered an error connecting to the AI service. Please check your API key.";
  }
};